import { roomInfoStore } from 'state/store';

export const selectRoom = () => {
    return roomInfoStore.room;
};

export const selectRoomMetadata = () => {
    return roomInfoStore.metadata;
};

export const selectRoomId = () => {
    return roomInfoStore.roomId;
};

export const selectDeltaWithServerTime = () => {
    return roomInfoStore.deltaWithServerTime;
};

export const selectHasRecorder = () => {
    return roomInfoStore.hasRecorder;
};

export const selectIsStatisticVisible = () => {
    return roomInfoStore.isStatisticVisible;
};

export const selectIsPreJoin = () => {
    return roomInfoStore.isPreJoin;
};
